import React from 'react';

import './styles.scss';

export interface RadioCheckboxProps {
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export function RadioCheckbox({ isChecked, onChange, disabled = false }: RadioCheckboxProps) {
  return (
    <label className="RadioCheckbox-wrapper">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={disabled}
        className="RadioCheckbox-input"
      />
      <span className="RadioCheckbox-visual">{isChecked && <span className="RadioCheckbox-dot"></span>}</span>
    </label>
  );
}
